import { render } from "./SectionItem.vue?vue&type=template&id=2b39c457&scoped=true"
import script from "./SectionItem.vue?vue&type=script&lang=js"
export * from "./SectionItem.vue?vue&type=script&lang=js"

import "./SectionItem.vue?vue&type=style&index=0&id=2b39c457&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b39c457"]])

export default __exports__